import AddSimInfoModal from './add-sim-info-modal.vue'
export default AddSimInfoModal
